import { Box, Typography } from "@mui/material";
import React from "react";

const FareBoundSliceCard = () => {
  return (
    <div>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 2,
          margin: "20px 0",
        }}>
        <img
          src={
            "https://upload.wikimedia.org/wikipedia/commons/d/d0/Emirates_logo.svg"
          }
          alt=""
          style={{
            width: "30px",
            height: "30px",
            borderRadius: "50%",
          }}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}>
          <Typography
            variant="h1"
            component="h1"
            sx={{
              fontSize: "14px",
              fontWeight: "bold",
            }}>
            11:30
          </Typography>
          <Typography variant="body1" component="code">
            BRU
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 0,
          }}>
          <Typography variant="body1" component="code">
            12h10m
          </Typography>
          <Typography variant="body1" component="code">
            --------------------------------
          </Typography>
          <Typography variant="body1" component="code">
            1st Stop
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}>
          <Typography
            variant="h1"
            component="h1"
            sx={{
              fontSize: "14px",
              fontWeight: "bold",
            }}>
            23:45
          </Typography>
          <Typography variant="body1" component="code">
            COO
          </Typography>
        </Box>
      </Box>
    </div>
  );
};

export default FareBoundSliceCard;
